import CountriesList from 'helpers/geoData/countries.json';

const countries = CountriesList;

export default countries;
